import { KnBrCommonService } from '../../services/kn-br-common.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { OrderActions } from '@spartacus/order/core';
import { ProductActions } from '@spartacus/core'
@Injectable()
export class KnBrSpinnerEffects {
orderDetailNotify$ = createEffect(() =>
  this.actions$.pipe(
    ofType(OrderActions.LOAD_ORDER_DETAILS),
    map((action: any) => action.payload),
    map((data) => this.knBrCommonServive.setSpinner(true))
  ),
  { dispatch: false }
);

orderDetailSuccessNotify$ = createEffect(() =>
  this.actions$.pipe(
    ofType(OrderActions.LOAD_ORDER_DETAILS_SUCCESS),
    map((action: any) => action.payload),
    map((data) => this.knBrCommonServive.setSpinner(false))
  ),
  { dispatch: false }
);

orderDetailFailureNotify$ = createEffect(() =>
  this.actions$.pipe(
    ofType(OrderActions.LOAD_ORDER_DETAILS_FAIL),
    map((action: any) => action.payload?.error),
    map((error: any) => this.knBrCommonServive.setSpinner(false))
  ),
  { dispatch: false }
);

returnOrderNotify$ = createEffect(() =>
  this.actions$.pipe(
    ofType(OrderActions.LOAD_ORDER_RETURN_REQUEST),
    map((action: any) => action.payload),
    map((data) => this.knBrCommonServive.setSpinner(true))
  ),
  { dispatch: false }
);
returnOrderSuccessNotify$ = createEffect(() =>
  this.actions$.pipe(
    ofType(OrderActions.LOAD_ORDER_RETURN_REQUEST_SUCCESS),
    map((action: any) => action.payload),
    map((data) => this.knBrCommonServive.setSpinner(false))
  ),
  { dispatch: false }
);

returnOrderFailureNotify$ = createEffect(() =>
  this.actions$.pipe(
    ofType(OrderActions.LOAD_ORDER_RETURN_REQUEST_FAIL),
    map((action: any) => action.payload?.error),
    map((error: any) => this.knBrCommonServive.setSpinner(false))
  ),
  { dispatch: false }
);
productSearch$ = createEffect(() =>
  this.actions$.pipe(
    ofType(ProductActions.SEARCH_PRODUCTS),
    map((action: any) => action),
    tap(action => {
      //This is required to skip showing spinner on search box typing.
      if (action.payload.queryText.indexOf(':') > -1) {
        this.knBrCommonServive.setSpinner(true)
      }
    })
  ),
  { dispatch: false }
);

productSearchSuccess$ = createEffect(() =>
  this.actions$.pipe(
    ofType(ProductActions.SEARCH_PRODUCTS_SUCCESS, ProductActions.SEARCH_PRODUCTS_FAIL),
    map((action: any) => action.payload)
  ),
  { dispatch: false }
);

  constructor(private actions$: Actions, private knBrCommonServive: KnBrCommonService) { }
}
